/**
 * Process Service for Outlook Add-in
 * Handles process data fetching from DoNexus API
 */

import apiClient from '../utils/apiClient';

class ProcessService {
  /**
   * Fetch all processes
   * @param {Object} params - Query parameters
   * @returns {Promise<Object>} Process list data
   */
  async getAllProcesses(params = {}) {
    try {
      let endpoint = '/process';
      
      // Build query string from params if provided
      if (params && Object.keys(params).length > 0) {
        const queryParams = new URLSearchParams(params).toString();
        endpoint += `?${queryParams}`;
      }
      
      const response = await apiClient.get(endpoint);
      
      if (response.success) {
        return {
          success: true,
          data: response.data,
          message: response.message
        };
      } else {
        throw new Error(response.message || 'Failed to fetch processes');
      }
    } catch (error) {
      console.error('Error fetching processes:', error);
      throw error;
    }
  }

  /**
   * Initialize an incident with a process
   * @param {string} incidentId - Incident UUID
   * @param {Object} data - Initialization data (process_id, instructions, thread_id, ai_execution)
   * @returns {Promise<Object>} Initialized incident data
   */
  async initializeIncident(incidentId, data = {}) {
    try {
      const response = await apiClient.put(`/incident/${incidentId}/initialize`, data);
      
      if (response.success) {
        return {
          success: true,
          data: response.data,
          message: response.message
        };
      } else {
        throw new Error(response.message || 'Failed to initialize incident');
      }
    } catch (error) {
      console.error('Error initializing incident:', error);
      throw error;
    }
  }
}

// Create singleton instance
const processService = new ProcessService();

export default processService;

